export enum IconButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
  Gray = 'gray',
  Dark = 'dark',
  Blue = 'blue',
}
